import React, { useEffect, useState } from 'react'
import Autocomplete from '../components/custom/autocomplete'
import { useDebounce } from '@react-hook/debounce'
import { useSelector } from 'react-redux'
import { RecruitsAeAPI } from '../services/recruit'

export default function InputAutocompleteAE({ value, onChange }) {
  const [searchAE, setSearchAE] = useDebounce('', 1000)
  const [isLoading, setIsLoading] = useState(false)
  const [codeAEOption, setCodeAEOption] = useState([])
  const roleId = useSelector((state) => state.roleReducer.role)
  const orgId = roleId
  useEffect(() => {
    const param = {
      page: 1,
      size: 10,
      searchs: searchAE,
      orgId
    }
    const getData = async () => {
      setIsLoading(true)
      const result = await RecruitsAeAPI(param)
      setIsLoading(false)
      if (!result) return
      if (result.status) {
        if (result.result.length > 0) {
          const newData = result.result.map((d, i) => {
            return { label: d.rc_no, value: d.rc_no }
          })

          setCodeAEOption(newData)
        } else {
          setCodeAEOption([])
        }
      } else {
        setCodeAEOption([])
      }
    }

    if (searchAE) {
      getData()
    } else {
      setCodeAEOption([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchAE])
  return (
    <Autocomplete
      isClearable={true}
      isLoading={isLoading}
      value={value}
      placeholder="Search AE No."
      options={codeAEOption}
      onChange={(e) => {
        onChange(e)
      }}
      onInputChange={(data) => {
        setSearchAE(data ? data.toUpperCase() : '')
      }}
    />
  )
}
